module.exports = __webpack_public_path__ + "assets/images/02a4cc87433a75a051f455c19662197d-notebook.png";